import apiZervant from '../../../../utils/apiZervant'

type FetchZervantInvoiceLogoResponse = { url: string }

export const fetchZervantInvoiceLogoUrl = async (tradeNameId: string) => {
  return apiZervant.platform.get<FetchZervantInvoiceLogoResponse>(`/v4/tradenames/${tradeNameId}/logo?noRedirect=true`)
}

export interface UploadZervantInvoiceLogoResponse {
  logoId: number
  url: string
}

export const uploadZervantInvoiceLogo = async (
  formData: FormData,
  tradeNameId: string,
): Promise<UploadZervantInvoiceLogoResponse> => {
  const response = await apiZervant.platform.post<UploadZervantInvoiceLogoResponse>(
    `/v4/logo?tradenameId=${tradeNameId}`,
    formData,
  )
  return response.data
}

export const deleteZervantInvoiceLogo = async (tradeNameId: string): Promise<void> => {
  await apiZervant.platform.delete(`/v4/tradenames/${tradeNameId}/logo`)
}
